export default __webpack_public_path__ + "static/media/temp-results-img.c97d7909.jpg";